<template>
  <div v-html="element.freeTextValue.value" />
</template>

<script>
export default {
  name: "FreeText",
  props: ["element"]
};
</script>